import React from "react";
export const ReplyArrow = () => (
  <svg viewBox="0 0 16 16">
    <path d="M6.4 5.3V2.2L1 7.6 6.4 13V9.9c3.9 0 6.6 1.2 8.6 4-.8-4-3.1-7.8-8.6-8.6z" />
  </svg>
);
